import _ from 'lodash'

/**
 * Data types defined in DataType.java
 */
export const NUMBER = 'number'
export const PERCENT = 'percent'
export const CURRENCY = 'currency'
export const YES_NO = 'yes-no'
export const TEXT = 'text'
export const DATE = 'date'
export const TIME = 'time'
export const DATE_TIME = 'date-time'
export const CALENDAR_PERIOD = 'calendar-period'
export const ROLLUP = 'rollup'
export const DATASET_LINK = 'dataset-link'
export const CLUSTER = 'cluster'
export const CONTINENT = 'continent'
export const COUNTRY = 'country'
export const STATE_PROVINCE = 'state-province'
export const COUNTY = 'county'
export const POSTAL_CODE = 'postal-code'
export const VOTING_DISTRICT = 'voting-district'
export const CITY = 'city'
export const ADDRESS = 'address'
export const LATITUDE = 'latitude'
export const LONGITUDE = 'longitude'
export const LATITUDE_LONGITUDE = 'latitude-longitude'
export const THRESHOLD_ID = 'threshold-id'
export const FILE = 'file'

export const COMPATIBLE_NUMERIC_DATA_TYPES = new Set([
	NUMBER, PERCENT, CURRENCY
])

export const COMPATIBLE_TO_AND_FROM_DATA_TYPES_NEEDING_CONVERSION = [{
	from: NUMBER,
	to: POSTAL_CODE
}]

function isCompatibleDataType(oldDataType, newDataType) {
	if (_.isNil(oldDataType) || _.isNil(newDataType)) return false
	if (oldDataType === newDataType) return true

	// #54021 we allow changing between certain data types, such as from a number to a postal code,
	// but not vice versa
	const validDataTypesToChangeTo = getValidDataTypesToChangeTo(oldDataType)
	if (_.includes(validDataTypesToChangeTo, newDataType)) return true

	return COMPATIBLE_NUMERIC_DATA_TYPES.has(oldDataType) &&
		COMPATIBLE_NUMERIC_DATA_TYPES.has(newDataType)
}

function getValidDataTypesToChangeTo(dataType) {
	const toAndFromDataTypes = _(COMPATIBLE_TO_AND_FROM_DATA_TYPES_NEEDING_CONVERSION)
		.filter(toAndFrom => dataType === toAndFrom.from)
		.map(toAndFrom => toAndFrom.to).value()
	// for some reason both, importing and requiring isNumericData type doesn't work in this file
	if (!COMPATIBLE_NUMERIC_DATA_TYPES.has(dataType)) return toAndFromDataTypes

	return Array.from(new Set(
		_.concat(toAndFromDataTypes, Array.from(COMPATIBLE_NUMERIC_DATA_TYPES))))
}

function hasValidTypeToChangeTo(dataType) {
	return !_.isEmpty(getValidDataTypesToChangeTo(dataType))
}

function getValidDataTypesToChangeFrom(dataType) {
	return _(COMPATIBLE_TO_AND_FROM_DATA_TYPES_NEEDING_CONVERSION)
		.filter(toAndFrom => dataType === toAndFrom.to)
		.map(toAndFrom => toAndFrom.from).value()
}

function hasValidTypeToChangeFrom(dataType) {
	return !_.isEmpty(getValidDataTypesToChangeFrom(dataType))
}

export default {
	NUMBER,
	PERCENT,
	CURRENCY,
	YES_NO,
	TEXT,
	DATE,
	TIME,
	DATE_TIME,
	CALENDAR_PERIOD,
	ROLLUP,
	DATASET_LINK,
	CLUSTER,
	CONTINENT,
	COUNTRY,
	STATE_PROVINCE,
	COUNTY,
	POSTAL_CODE,
	VOTING_DISTRICT,
	CITY,
	ADDRESS,
	LATITUDE,
	LONGITUDE,
	LATITUDE_LONGITUDE,
	THRESHOLD_ID,
	FILE,
	COMPATIBLE_NUMERIC_DATA_TYPES,
	COMPATIBLE_TO_AND_FROM_DATA_TYPES_NEEDING_CONVERSION,
	isCompatibleDataType,
	getValidDataTypesToChangeTo,
	hasValidTypeToChangeTo,
	getValidDataTypesToChangeFrom,
	hasValidTypeToChangeFrom
}
export { isCompatibleDataType }
export { hasValidTypeToChangeTo }
export { getValidDataTypesToChangeTo }
export { hasValidTypeToChangeFrom }
export { getValidDataTypesToChangeFrom }